import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary text-slate-300 py-12 border-t border-secondary/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <span className="text-2xl font-bold text-white tracking-tight mb-4 block">
            ENVISU<span className="text-accent">.</span>
          </span>
          <p className="text-sm">
            Digitale Qualitätssicherung auf höchstem Niveau. <br/>
            Exakt geprüft.
          </p>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4">Kontakt & Impressum</h3>
          <ul className="space-y-2 text-sm">
            <li><strong>ENVISU GmbH</strong></li>
            <li>Dankwartsgrube 51</li>
            <li>23552 Lübeck</li>
            <li className="pt-2">Vertreten durch: Bernd Spautz</li>
            <li>E-Mail: <a href="mailto:kontakt@envisu-gmbh.com" className="hover:text-accent">kontakt@envisu-gmbh.com</a></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4">Tester-Netzwerk</h3>
          <ul className="space-y-2 text-sm flex flex-col">
            <Link to="/mitarbeiter/login" className="hover:text-accent transition-colors">Zum Tester-Login</Link>
            <Link to="/karriere" className="hover:text-accent transition-colors">Als Tester bewerben</Link>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4">Rechtliches</h3>
          <ul className="space-y-2 text-sm flex flex-col">
            <Link to="/impressum" className="hover:text-accent transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-accent transition-colors">Datenschutzerklärung</Link>
            <Link to="/kontakt" className="hover:text-accent transition-colors">Kontakt</Link>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-secondary/50 text-sm text-center">
        &copy; {new Date().getFullYear()} ENVISU GmbH. Alle Rechte vorbehalten.
      </div>
    </footer>
  );
}